// src/plugins/echo.js
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import api from './baseURL'
window.Pusher = Pusher;

let echoInstance = null; // on garde l'instance ici
let presenceInstance = null;
let currentToken = null;

export default {
  install(Vue) {
    Vue.prototype.$initEcho = () => {
      const token = localStorage.getItem("tokenMinu"); // token au moment de l'initialisation

      if (!token) return null;
      if (echoInstance && token === currentToken) return echoInstance;
      echoInstance?.disconnect();
      presenceInstance?.disconnect();
      currentToken = token;

      //console.log('token ok sur initEcho');

      // Configuration propre à chaque environnement dans baseURL.js (non versionné).
      const reverb = api.reverb || {};
      const options = {
        broadcaster: 'reverb',
        key: api.reverbAPIkey,
        wsHost: api.rootAPI,
        wsPort: reverb.wsPort ?? 6001,
        forceTLS: reverb.forceTLS ?? (window.location.protocol === 'https:' || api.root.startsWith('https:')),
        wssPort: reverb.wssPort ?? 443,
        enabledTransports: ['ws'],
        authEndpoint: `${api.root}broadcasting/auth`,
        auth: {
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization',
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
    }
        }
      };
      echoInstance = new Echo(options);
      presenceInstance = new Echo(options);
      //console.log('echo loaded')
      return echoInstance;
    };

    Vue.prototype.$echo = () => echoInstance; // permet d’accéder à l’instance déjà créée
    Vue.prototype.$presenceEcho = () => presenceInstance;
  }
}
